import { SVGProps } from '@components/Icon/types';

export const Star = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(1.5, 2)">
      <path
        d="M9.52148 1.30664C9.92507 0.497788 11.0749 0.497821 11.4785 1.30664L13.3057 4.9707H13.3066C13.5815 5.52088 14.1052 5.90516 14.7139 5.99902L19.3701 6.7168C20.2542 6.85355 20.6128 7.94209 19.9775 8.5791L19.9766 8.58008L16.8398 11.7236C16.4131 12.1514 16.216 12.7575 16.3076 13.3545L17.0254 18.0303C17.1625 18.9235 16.2291 19.5859 15.4375 19.1719L11.3779 17.0488H11.377C10.8956 16.798 10.3343 16.7657 9.83301 16.9541L9.62207 17.0488L5.5625 19.1719C4.81996 19.5601 3.95455 19.0024 3.96191 18.1953L3.97559 18.0303L4.69238 13.3545C4.78396 12.7575 4.58688 12.1514 4.16016 11.7236L1.02344 8.58008C0.387194 7.94234 0.745536 6.85361 1.62988 6.7168L6.28613 5.99902C6.81875 5.91689 7.28632 5.61227 7.5791 5.16895L7.69434 4.9707L9.52148 1.30664Z"
        stroke={fill}
        strokeWidth="1.4"
        fill="none"
      />
    </g>
  </svg>
);

export const ICON_NAME = 'star';
